import React from 'react';
import { useTranslation } from 'react-i18next';
import Tip from '../Tip/Tip';
import styles from './sass/M1Tips.module.scss';

const TipFunctionalDriver = () => {
  const { t } = useTranslation();
  return (
    <Tip
      styleTipTextContainer={styles.driverContainer}
      styleTriangle={styles.triangle}
    >
      <p>
        {t('tipFunctionalDriver')}
      </p>
    </Tip>
  );
};

export default TipFunctionalDriver;
